import { Box, Container, Typography, styled } from "@mui/material";
import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import logo from "../../Components/images/mainlogo.png";
import { useState } from "react";
import HorizontalNav from "./HorizontalNav";
import { MenuRounded } from "@mui/icons-material";
import { NavLink } from "react-router-dom";

const StyledLink = styled(NavLink)(() => ({
  textDecoration: "none",
  "&:focus, &:hover, &:visited, &:link, &:active": {
    textDecoration: "none",
    color: "black",
  },
}));
const NewHeroSection = () => {
  const [state, setState] = useState(false);

  const toggleDrawer = (open) => {
    setState((prevState) => !prevState);
  };

  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);

  const particleOptions = {
    autoPlay: true,
    background: {
      color: {
        value: "transparent",
        opacity: "0.2",
      },
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
      },
      modes: {
        grab: {
          distance: 200,
          links: {
            opacity: 0.8,
          },
        },
      },
    },
    particles: {
      number: {
        value: 200,
      },
      color: {
        value: "#a0c8f0",
      },
      shape: {
        type: "polygon",
        polygon: {
          sides: 15,
        },
      },
      move: {
        // Enable particle movement
        enable: true,
        // Set the speed of particles
        speed: 2,
        // Enable particles to bounce off the edges
        bounce: true,
      },

      size: {
        value: 1, // Decrease the value to decrease particle size
        random: true, // Enable random size variation
        anim: {
          enable: false, // Disable size animation
          speed: 0, // Set animation speed to 0 (disabled)
          size_min: 0, // Set minimum size during animation
        },
      },
    },
  };

  return (
    <Box
      sx={{
        position: "relative",
        background:
          " linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
        /* Additional styles for the container */
        width: "100%",
        height: " 100vh",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />

      <Container>
        <Box
          sx={{ position: "absolute", top: 0, left: 10, right: 10, bottom: 0 }}
        >
          <HorizontalNav toggleDrawer={toggleDrawer} state={state} />
          <StyledLink to="/">
            <Box
              component={"img"}
              src={logo}
              width="100px"
              alt="logo"
              sx={{ opacity: "0.6 " }}
            />
          </StyledLink>

          <Box
            height={"75%"}
            display={"flex"}
            gap={10}
            alignItems={"center"}
            ml={3}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Typography>Menu</Typography>
              <MenuRounded
                sx={{ color: "#fff", fontSize: "3rem", cursor: "pointer" }}
                onClick={() => toggleDrawer(true)}
              />
            </Box>
            <Box width={{ lg: "50%", md: "80%" }} mt={6}>
              <Typography
                sx={{
                  fontSize: "50px",
                  fontFamily: "Roboto Slab",
                  color: "#CA3A38",
                  fontWeight: "900",
                }}
              >
                Our Vision
              </Typography>
              <Typography
                sx={{
                  fontSize: "40px",
                  fontFamily: "Roboto Slab",
                  color: "#fff",
                  fontWeight: "700",
                }}
              >
                Unleashing the Power of Staking
              </Typography>
              <Typography sx={{ fontSize: "20px", fontFamily: "Lato", mt: 1 }}>
                At De-Fi Sage, we are passionate about empowering individuals to
                take control of their financial future through decentralized
                finance (DeFi) solutions. Our mission is to revive staking and
                bring it to the forefront of the rapidly evolving digital
                landscape.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <NavLink to="/explore" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  cursor: "pointer",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  fontWeight: "400",
                  color: "#fff",
                  border: "2px solid white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  lineHeight: "18px",
                  transition: "1s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "#E0115F",
                    transition: "1s ease-in-out",
                  },
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Lato",
                      textAlign: "center",
                      textTransform: "uppercase",
                    }}
                  >
                    Explore
                  </Typography>
                </Box>
              </Box>
            </NavLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NewHeroSection;
